import React from 'react';

import { BANNER_POSITION, bannerPositions } from '../../constants/banners';

import Classes from './BannerRight.scss';

const BannerRight = () => (
  <div
    id={bannerPositions[BANNER_POSITION.STATIC.RIGHT].id}
    className={`${Classes.root} hz-Page-section hz-Page-section--separated`}
  />
);

export default BannerRight;
